<template>
  <v-container class="bg-gray fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <slot />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {}
</script>
